import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import Subscription from "@/views/OffcanvasViews/Subscription/Subscription.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'SubscriptionModal',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_ModalComponent = _resolveComponent("ModalComponent")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_ModalComponent, {
      id: "subscription_modal",
      title: "Assinatura Psiapp",
      bodyClass: "p-0 pb-4"
    }, {
      body: _withCtx(() => [
        _createVNode(Subscription)
      ]),
      _: 1
    })
  ]))
}
}

})